<template>
    <div class="liga">
        <Navbar showBackButton></Navbar>

        <div class="poveznice">
            <Poveznice></Poveznice>
        </div>

        <div class="container" v-if="!loaded">
            Učitavanje
        </div>

        <transition name="fade-translate" appear>
            <div class="container" v-if="loaded">
                <PanelPokreni v-if="appState == 'round-in-progress'"/>

                <h2 class="league-title">Moja Grupa</h2>
                <div class="liga-card-wrapper">
                    <GrupaSingle :groupId="userData.groupOwner" v-if="userData.groupOwner"></GrupaSingle>
                    <NoResults v-if="!userData.groupOwner">GrupaSingle
                        <template v-slot:error-content>
                            <p class="text">Niste vlasnik/ca niti jedne grupe, kreirajte svoju grupu
                                <router-link to="/kreiraj-grupu">ovdje</router-link>
                                i natječite se sa svojim prijateljima
                            </p>
                        </template>
                    </NoResults>
                </div>
            </div>
        </transition>

        <transition name="fade-translate">
            <div class="container" v-if="loaded && notOwnGroups && notOwnGroups.length > 0">
                <h2 class="league-title">Grupe u kojima sudjelujem</h2>
                <div class="liga-card-wrapper">
                    <GrupaSingle :groupId="groupId" v-for="groupId in notOwnGroups" v-bind:key="groupId"></GrupaSingle>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Poveznice from '../components/Poveznice.vue'
import GrupaSingle from '../components/group/GrupaSingle'
import NoResults from '../components/common/error/NoResults'
import PanelPokreni from '../components/PanelPokreni'
export default {
    name: 'moje_grupe',
    data: function () {
        return {
            inGroups: false
        }
    },
    components: {
        Navbar,
        Poveznice,
        GrupaSingle,
        NoResults,
        PanelPokreni
    },
    async mounted () {
        const data = await this.$db.grupe.getAllMyGroupIds(this.uid)
        if (data) {
            this.inGroups = data
        }
    },
    computed: {
        loaded () {
            try {
                return !!(this.metadata.loaded && this.userData)
            } catch (error) {
                return false
            }
        },
        metadata () {
            try {
                return this.$store.state.metadata
            } catch (error) {
                return false
            }
        },
        uid () {
            try {
                return this.$store.state.user.uid
            } catch (error) {
                return false
            }
        },
        userData () {
            try {
                return this.metadata.userData
            } catch (error) {
                return false
            }
        },
        notOwnGroups () {
            if (this.userData.groupOwner && this.inGroups) {
                return this.inGroups.filter(elem => elem !== this.userData.groupOwner)
            } else if (this.inGroups && this.userData.groupOwner === undefined) {
                return this.inGroups
            }
            return []
        },
        appState () {
            return this.$store.state.appState
        }
    }
}
</script>

<style lang="scss" scoped>
.liga {
    padding-top: 22px;
    .poveznice {
        margin-bottom: 30px;
    }
    .container {
        *:not(.panel-pokreni) {
            text-align: left;
        }
        padding-bottom: 30px;
    }
    .panel-pokreni {
        margin-bottom: 30px;
    }
}

@media only screen and (min-width: 800px) {
    .liga {
        max-width: 1280px;
        margin: auto;
    }
}
</style>
